// extracted by mini-css-extract-plugin
module.exports = {"gfeButton":"GfeButton_gfeButton__2xKN4"};